import React, { useEffect, useState, useRef } from "react";
import { Animated, Platform, StyleSheet, TouchableOpacity, Image as ImageReact, View, AppState, ActivityIndicator } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, CreditLoadingPageType, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Lottie } from "../../lottie/Lottie";
import { Typography } from "../../typography/Typography";
import { addCommasToNumber } from "../utils";
import { Icon } from "../../icon/Icon";
import LottieView from "lottie-react-native";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import LinearGradient from 'react-native-linear-gradient';
import { PLATFORM_NAME } from "../constants";
import { isFontMobile } from "../../stack/utils";
import Divider from "../../divider/Divider";
import Space from "../../space/Space";
// import LottieView from "lottie-react-native";
const CreditLoadingDownload = ({ height, triggerAction, helpAction, isSuccessful = true, continueAction, availableCreditLimitAmount, lenderData, type, }) => {
    const [SlideInLeft1, setSlideInLeft1] = useState(new Animated.Value(1));
    const [SlideInLeft2, setSlideInLeft2] = useState(new Animated.Value(0));
    const availableCredLimit = isNaN(Number(availableCreditLimitAmount)) ? "Unavailable" : `${addCommasToNumber(Number(availableCreditLimitAmount))}`;
    const [_lenderData, setLenderData] = useState(lenderData);
    const [hourGlassLottie, setHourGlassLottie] = useState("");
    const isCibilOrCheckElibility = (type) => {
        return (type === CreditLoadingPageType.CHECK_ELIGIBILITY
            || type === CreditLoadingPageType.CIBIL);
    };
    const url = Platform.OS === 'web' ? window.location.href : '';
    const isFromPhonePe = url.includes(PLATFORM_NAME.PHONEPE);
    const [appState, setAppState] = useState(AppState.currentState);
    const animationRef = useRef(null);
    const [showFaq, setShowFaq] = useState(false);
    useEffect(() => {
        const handleAppStateChange = (nextAppState) => {
            if (appState.match(/inactive|background/) && nextAppState === 'active') {
                if (animationRef.current) {
                    animationRef.current.play();
                }
            }
            setAppState(nextAppState);
        };
        // Add the event listener when the component mounts
        AppState.addEventListener('change', handleAppStateChange);
        // Remove the event listener when the component unmounts
        return () => {
            //@ts-ignore
        };
    }, [appState]);
    useEffect(() => {
        if (Platform.OS === 'ios') {
            fetch("https://lottie.host/ce1a5285-9074-4316-871b-081377ea1b24/4nfIbLjIMG.json", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((responseData) => {
                console.log(responseData);
                setHourGlassLottie(responseData);
            })
                .catch((error) => {
                console.log(error);
            });
        }
    }, []);
    useEffect(() => {
        if (true) {
            Animated.parallel([
                Animated.timing(SlideInLeft1, {
                    toValue: 0,
                    duration: 500,
                    useNativeDriver: false,
                }),
                Animated.timing(SlideInLeft2, {
                    toValue: 1,
                    duration: 1000,
                    useNativeDriver: false,
                }),
            ]).start();
        }
    }, [isSuccessful]);
    const creditApprovedWithAnimation = () => {
        return (React.createElement(Animated.View, { style: {
                opacity: SlideInLeft2,
                flex: 1,
                width: '100%',
                backgroundColor: "white",
                justifyContent: "center"
            } }, creditApproved()));
    };
    const renderPhonePeDownloadCard = () => {
        return (React.createElement(View, { style: { flex: 1, marginBottom: 16 } },
            React.createElement(LinearGradient, { colors: ['#12B76A', '#FFFFFF'], start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, style: { flex: 0.5 } },
                React.createElement(View, { style: { flex: 1 } },
                    React.createElement(View, { style: { marginTop: 40, alignItems: 'center' } },
                        React.createElement(ImageReact, { source: { uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Frame+41.png` }, style: styles.voltImage })),
                    React.createElement(View, { style: { marginTop: 24, alignItems: 'center' } },
                        React.createElement(Lottie, { uri: LottieTokens.PhonePe_Success, size: LottieSizeTokens.Size_56 })),
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: 24
                        } },
                        React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Secondary_300, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                        React.createElement(Typography, { label: `${availableCredLimit}`, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Secondary_300 })),
                    React.createElement(View, { style: { alignItems: 'center', marginTop: 8 } },
                        React.createElement(Typography, { label: 'Credit line opened successfully', typeDLS: TypographyTypeDLS.B0M, color: ColorTokens.Secondary_300 })),
                    React.createElement(View, { style: { marginTop: 48, paddingHorizontal: 24, paddingBottom: 32, paddingTop: 24, borderRadius: 16, borderWidth: 1, borderColor: '#F1F3F5', backgroundColor: 'white', marginHorizontal: 16,
                            shadowColor: "rgba(12, 25, 86, 0.08)",
                            shadowOffset: {
                                width: 0,
                                height: 20,
                            },
                            shadowRadius: 40,
                            elevation: 40,
                            shadowOpacity: 1, } },
                        React.createElement(Typography, { label: "Withdraw cash instantly on the Volt Money app", typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night }),
                        React.createElement(View, { style: { marginTop: 32, width: '100%', alignItems: 'center' } },
                            React.createElement(ButtonDLSBase, { onPress: () => {
                                    if (continueAction) {
                                        triggerAction(continueAction);
                                    }
                                }, typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.LARGE, iconName: IconTokens.Download, label: 'Download Volt Money' })),
                        React.createElement(View, { style: { flexDirection: 'row', marginTop: 8, justifyContent: 'center' } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Available on', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.center }),
                            React.createElement(Space, { size: SizeTypeTokens.MD }),
                            React.createElement(ImageReact, { source: {
                                    uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/65f9cb6caca2c8495541c73d012ae77b679892f4dada2d8eb410c8b9d5b3b569?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                                }, style: { width: 20, position: 'relative' } }),
                            React.createElement(Space, { size: SizeTypeTokens.MD }),
                            React.createElement(ImageReact, { source: {
                                    uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/0e66cbbeea02146197d456ed8115023b851967fed06fcaa956a7a7e1c74ec03d?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                                }, style: { width: 20, position: 'relative' } }))),
                    React.createElement(View, { style: { marginVertical: 40 } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(Typography, { label: "FAQ", typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Smoke }),
                    React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flexDirection: 'row', alignItems: 'center', paddingTop: 16, paddingBottom: 8, justifyContent: 'space-between' }, onPress: () => {
                            setShowFaq(!showFaq);
                        } },
                        React.createElement(Typography, { label: 'How do I withdraw cash from my credit line?', color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B1S }),
                        React.createElement(Icon, { name: showFaq ? IconTokens.UpsideArrow : IconTokens.DownArrow, size: IconSizeTokens.SM, color: ColorTokens.Grey_Night })),
                    showFaq &&
                        React.createElement(View, null,
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "1. ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: "Download ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Volt Money app", color: ColorTokens.Grey_Charcoal })),
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "2. ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: "Log in ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "with your phone number", color: ColorTokens.Grey_Charcoal })),
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "3. ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Click on the ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: "withdraw ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "button", color: ColorTokens.Grey_Charcoal })),
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "4. ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Get cash in your account in ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: "4-5 ", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "business hours", color: ColorTokens.Grey_Charcoal })))))));
    };
    const creditApproved = () => {
        return isFromPhonePe ? renderPhonePeDownloadCard() : (React.createElement(View, { style: { height: height - 18, padding: 16 } },
            React.createElement(View, { style: {
                    alignItems: 'center',
                    width: '100%',
                    flexDirection: 'column',
                    marginTop: 32,
                    flex: 1,
                } },
                React.createElement(Typography, { fontWeight: "600", fontSize: FontSizeTokens.XL, lineHeight: 28, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, label: "Congratulations!", textAlign: TextAlignTokens.center }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { fontWeight: "400", fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, label: "Your account has been\nsuccessfully opened", textAlign: TextAlignTokens.center })),
                React.createElement(View, { style: {
                        padding: 16,
                        width: "100%",
                        marginTop: 24,
                        marginRight: 8,
                        marginLeft: 8,
                        borderRadius: 16,
                        shadowColor: "rgba(12, 25, 86, 0.08)",
                        shadowOffset: {
                            width: 0,
                            height: 20,
                        },
                        shadowRadius: 40,
                        elevation: 40,
                        shadowOpacity: 1,
                        borderStyle: "solid",
                        borderColor: "#f1f3f5",
                        borderWidth: 1,
                        left: 0,
                        top: 0,
                        backgroundColor: "#fff",
                    } },
                    React.createElement(Typography, { fontWeight: "400", fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, label: "Available cash" }),
                    React.createElement(View, { style: { marginTop: 4, flexDirection: 'row' } },
                        React.createElement(Typography, { fontWeight: "900", fontSize: FontSizeTokens.XXXXL, lineHeight: 40, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, label: '₹' }),
                        React.createElement(Typography, { fontWeight: "900", fontSize: FontSizeTokens.XXXXL, lineHeight: 40, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, label: `${availableCredLimit}` })),
                    React.createElement(View, { style: { justifyContent: 'flex-end', marginTop: 50 } },
                        React.createElement(Typography, { fontSize: FontSizeTokens.XXS, fontFamily: FontFamilyTokens.Inter, fontWeight: "400", lineHeight: 16, color: ColorTokens.Grey_Charcoal, label: "100% of total limit available" }),
                        React.createElement(View, { style: {
                                height: 6,
                                width: '100%',
                                backgroundColor: "#109648",
                                marginTop: 4,
                                borderRadius: 8
                            } })))),
            React.createElement(View, { style: styles.overlay }, Platform.OS === 'ios' ?
                React.createElement(LottieView, { ref: animationRef, source: { uri: "https://lottie.host/19405fb0-a051-4310-8f30-53992f37447c/Bdx1gocQfp.json" }, style: { width: '100%', height: 'auto', flex: 1 }, autoPlay: true, loop: false }) :
                React.createElement(Lottie, { uri: LottieTokens.UnlockNew, size: LottieSizeTokens.FULL, autoplay: true, loop: false })),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: 51, alignContent: 'center', alignItems: 'center', width: '100%', alignSelf: 'center' } },
                React.createElement(Typography, { label: "To withdraw from your credit line easily", typeDLS: TypographyTypeDLS.B1M }),
                React.createElement(View, { style: { marginTop: 8, width: '100%' } },
                    React.createElement(ButtonDLSBase, { onPress: () => {
                            if (continueAction) {
                                triggerAction(continueAction);
                            }
                        }, typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.LARGE, iconName: IconTokens.Download, label: 'Download Volt Money Now' })),
                React.createElement(View, { style: { flexDirection: 'row', marginTop: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Available on', color: ColorTokens.Grey_Smoke }),
                    React.createElement(ImageReact, { source: {
                            uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/65f9cb6caca2c8495541c73d012ae77b679892f4dada2d8eb410c8b9d5b3b569?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                        }, style: styles.image2 }),
                    React.createElement(ImageReact, { source: {
                            uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/0e66cbbeea02146197d456ed8115023b851967fed06fcaa956a7a7e1c74ec03d?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                        }, style: styles.image3 })))));
    };
    const creditStatusLoading = () => {
        return (React.createElement(Animated.View, { style: {
                opacity: SlideInLeft1,
                flex: 1,
                height: height - 90,
                width: '100%',
                backgroundColor: "white",
                justifyContent: "center"
            } },
            React.createElement(View, { style: { height: Platform.OS !== 'web' ? height - 60 : height - 114, padding: 16 } },
                React.createElement(View, { style: styles.bodyContainer },
                    Platform.OS === 'ios' ?
                        React.createElement(React.Fragment, null,
                            React.createElement(LottieView, { ref: animationRef, source: { uri: "https://lottie.host/ce1a5285-9074-4316-871b-081377ea1b24/4nfIbLjIMG.json" }, style: { width: 128, height: 128 }, autoPlay: true, loop: true }))
                        : React.createElement(React.Fragment, null,
                            React.createElement(Lottie, { uri: LottieTokens.SandTimer, size: LottieSizeTokens.XXL })),
                    React.createElement(Typography, { label: !isCibilOrCheckElibility(type)
                            ? "You're just a step away! Getting your account ready."
                            : "Verifying your details...", color: ColorTokens.Grey_Night, lineHeight: 24, fontWeight: "600", fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, textAlign: TextAlignTokens.center }),
                    React.createElement(View, { style: { marginTop: 8 } },
                        React.createElement(Typography, { label: !isCibilOrCheckElibility(type)
                                ? "It may take 10-15 Seconds..."
                                : "It may take up to 30 seconds...", fontFamily: FontFamilyTokens.Inter, lineHeight: 20, fontWeight: "400", fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center }))))));
    };
    return availableCreditLimitAmount ? creditApprovedWithAnimation() : React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 250 } },
        React.createElement(ActivityIndicator, { size: "large" }));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    image2: { position: 'relative', width: 20 },
    image3: { position: 'relative', width: 20 },
    voltImage: {
        height: 20,
        width: 40
    }
});
// @ts-ignore
export default (CreditLoadingDownload);
